/**
 * Dependencies
 */
import { API_ROOT, REACT_APP_URL } from './api-config';
const request = require('axios');

/**
 * Environment / config
 */

//const API_URL_DEV = 'https://dn.dmlf.hf.uio.no/ny-damos/ajaxgetfilter'
//const API_URL_DEV_GET_FILTER = 'https://dn.dmlf.hf.uio.no/ny-damos/ajaxfilter'
//const API_URL_DEV_GET_TABLE = 'https://dn.dmlf.hf.uio.no/ny-damos/ajaxitem/'
//const API_URL_DEV_WORDSEARCH = 'https://dn.dmlf.hf.uio.no/ny-damos/wordsearch'
//const valgtArray = [];


function wordsearchsimple(formdata, filter) {
    return request(`${API_ROOT}${REACT_APP_URL}wordsearch`, {
      method: 'POST',
      timeout: 20000,
      data: JSON.stringify({
      toyou: Object.assign({"filtervalues": filter}, formdata)
    })})
  .then(({data}) => data)
  .catch(function (error) {
    alert("Connection timeout. Please narrow your search")
    throw error

  });
}



function wordsearchmultiple(formdata, filter) {
    return request(`${API_ROOT}${REACT_APP_URL}multippelwordsearch`, {
      method: 'POST',
      timeout: 20000,
      data: JSON.stringify({
      toyou: Object.assign({"filtervalues": filter}, formdata)
    })})
  .then(({data}) => data)
  .catch(function (error) {
    alert("Connection timeout. Please narrow your search")
    throw error

  });
}

/* denne inneholder valgt filter */
/* flyttet denne til reducer, hvis buggy, fjern */
/*
function valgtFunc(ent){
  if (valgtArray.indexOf(ent) > -1) {
  valgtArray.splice(valgtArray.indexOf(ent), 1); //c__1
} else {
  valgtArray.push(ent);
}
}
*/

/**
 * Service for getting messages
 */
function getMessages() {
  return request.post(`${API_ROOT}${REACT_APP_URL}ajaxgetfilter`)
  .then(({ data}) => data );
}

function getlegend(){
  return request(`${API_ROOT}${REACT_APP_URL}ajaxgetlegend/`, {
  }).then(({data}) => data)
.catch(function (error) {
  alert(error)
  //throw error
});
}

function itemhintdata(itemid){
  return request(`${API_ROOT}${REACT_APP_URL}ajaxitemcontent/`+itemid, {
  }).then(({data}) => data)
.catch(function (error) {
  alert(error)
  //throw error
});
}

/**
 * Service for getting tables based on filter
 */
function getFilter(entity, choosenElements) {
  //valgtFunc(entValue)
    return request(`${API_ROOT}${REACT_APP_URL}ajaxfilter`, {
      method: 'POST',
      responseType: 'json',
      data: JSON.stringify({
      toyou: choosenElements,
      //checked: checked
      checked: ""
    })})
  .then(({data}) => data )
  .catch(function (error) {
    console.log(error);
  });
}

/**
* Service for getting tables
*/
function getTable(tableid){
  return request(`${API_ROOT}${REACT_APP_URL}ajaxitem/`+tableid+"/", {
  }).then(({data}) => data)
  .catch(function (error){
    console.log(error);
  })
}
/**
 * Service for submitting a message

function submitMessage({ name, text }) {
  return request.post(API_URL_DEV, { name, text });
}
*/
/**
 * Export
 */
export default {
  getMessages: getMessages,
  itemhintdata: itemhintdata,
  wordsearchsimple: wordsearchsimple,
  wordsearchmultiple: wordsearchmultiple,
  getTable: getTable,
  getlegend: getlegend,
  getFilter: getFilter,
};



// WEBPACK FOOTER //
// ./src/services/damos.js